import React, { useState, useEffect, useRef, useContext, useCallback } from "react";
import { Button, Dialog, Toast } from "primereact";
import { InputText } from "primereact/inputtext";

import AutoCompleteDropdown from "../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../Base/Hooks/useForm";
import Loader from "../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../Base/Services/ToastService";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { getLabel } from "../../../Base/Services/Language/LanguageService";

import { EditarYarnSpandex, EditarYarnSynthetic, getCalibres, getLoster, getYarn, GuardarYarnSinthetic, GuardarYarnSpandex, ObtenerSiguienteCorrelativoC, ObtenerSiguienteCorrelativoS } from "../../../API/Desarrollo/DesarrolloRequest";

const YarnSpandexCRUD = ({
  dialog,
  setDialog,
  selected,
  setSelected,
  modo,
  getInfo,
}) => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [calibres, setCalibres] = useState([]);
  const [loster, setLoster] = useState([]);
  const [titulo, setTitulo] = useState(null);
  const [button, setButton] = useState(null);
  

  const initialValues = {
    IdYarnTitle: -1,
    IdStatus: selected ? selected?.IdStatus : 3706,
    IdStyleCategory: 1,
  };

  const origen = [
    { IdOrigin: 1, Origin: "CAFTA" },   
    { IdOrigin: 2, Origin: "NO CAFTA" },   
  ]  

  const tipoTejido = [
    { IdTipoTejido: 1, TipoTejido: "CIRCULAR" },   
    { IdTipoTejido: 2, TipoTejido: "WARP" },   
  ]  


  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);

    const calibresTempo = await getCalibres()
    setCalibres(calibresTempo.filter(i => i.IdStyleCategory === 1))
    const calibreInicial = modo === "Crear" ? calibresTempo : calibresTempo.find((e) => e.IdCalibre === selected?.IdCalibre);

    const losterTempo = await getLoster()
    setLoster(losterTempo)
    const losterInicial = modo === "Crear" ? losterTempo : losterTempo.find((e) => e.IdLoster === selected?.IdLoster);

    const resp = await ObtenerSiguienteCorrelativoC()
    const corretativo = modo === "Crear" ? resp[0]?.Correlativo : selected?.Correlativo;

    setValues({
      ...selected,
      IdYarnTitle: selected ? selected?.IdYarnTitle : -1,
      Correlativo: corretativo,
      Calibre: calibreInicial?.Calibre,
      IdCalibre: calibreInicial?.IdCalibre,
      IdLoster: losterInicial?.IdLoster,
      Loster: losterInicial?.Loster,
      IdStyleCategory: 1,
      IdOrigin: selected?.IdOrigin ? selected?.IdOrigin : null,
      Origin: selected?.Origin ? selected?.Origin : null,
      IdTipoTejido: selected?.IdTipoTejido ? selected?.IdTipoTejido : null,
      TipoTejido: selected?.TipoTejido ? selected?.TipoTejido : null,
      Denier : selected?.Denier ? selected?.Denier : null,
    });
    setLoading(false);
  };

  const onHide = () => {
    setDialog(false);
    setSelected(null);
  };

  const verificarInfo = () => {
    let error = {};

    if (modo === "Crear") {

      if (!values.Calibre) {
        error.IdCalibre = true;
        error.error = true;
      }
      // if (!values.TipoTejido) {
      //   error.IdTipoTejido = true;
      //   error.error = true;
      // }
      if (!values.Origin) {
        error.IdOrigin = true;
        error.error = true;
      }
    } else {
      if (!values.Calibre) {
        error.IdCalibre = true;
        error.error = true;
      }
      if (!values.Origin) {
        error.IdOrigin = true;
        error.error = true;
      }
    }
    
    setError(error);
    return error;
  };

  const agregarDatos = async () => {
    const e = verificarInfo();

    if (!e.error) {
      const Datos = {
        IdYarnTitle: values?.IdYarnTitle,
        IdStyleCategory: 1,
        Yarn: values?.Yarn,
        IdCalibre: values?.IdCalibre || values?.Calibre?.IdCalibre,
        IdLoster: values?.IdLoster || values?.Loster?.IdLoster,
        IdOrigin: values?.IdOrigin || values?.Origin?.IdOrigin,
        Origin: values?.Origin?.Origin ||  values?.Origin,
        IdUserCreate: userAuth?.idUser,
        IdUserEdit: userAuth?.idUser,
        IdTipoTejido: values?.IdTipoTejido || values?.TipoTejido?.IdTipoTejido,
        TipoTejido: values?.TipoTejido?.TipoTejido ||  values?.TipoTejido,
      };

      setLoading(true);
      if (values?.IdYarnTitle > 0) {
        const respuesta = await EditarYarnSpandex(Datos);
        if (respuesta[0].ESTADO !== -1) {
          toastShow(toast, "success", "Datos Agregados", respuesta[0].MENSAJE);
          setTimeout(() => {
            // onHide();
            obtenerInformacion(respuesta[0]?.IdYarnTitle)
            setLoading(false);
            getInfo();
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
          setLoading(false);
        }
      } else {
        const respuesta = await GuardarYarnSpandex(Datos);
        if (respuesta[0].ESTADO !== -1) {
          toastShow(toast, "success", "Datos Agregados", respuesta[0].MENSAJE);
          setTimeout(() => {
            // onHide();
            obtenerInformacion(respuesta[0]?.IdYarnTitle)
            setLoading(false);
            getInfo();
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
          setLoading(false);
        }
      }
    }
  };

  const obtenerInformacion = async (IdYarnTitle) => {
    setLoading(true)

    const encTempo = await getYarn()
    setTitulo('Editar Yarn Synthetic')

    let encabezadoTempo = encTempo?.filter(i => i.IdYarnTitle === IdYarnTitle)

    setValues({
      ...encabezadoTempo,
      IdYarnTitle: encabezadoTempo[0]?.IdYarnTitle,
      Calibre: encabezadoTempo[0]?.Calibre,
      IdCalibre: encabezadoTempo[0]?.IdCalibre,
      Play: encabezadoTempo[0]?.Play,
      Ply: encabezadoTempo[0]?.Play,
      IdType: encabezadoTempo[0]?.IdType,
      Type: encabezadoTempo[0]?.Type,
      IdOrigin: encabezadoTempo[0]?.IdOrigin,
      Origin: encabezadoTempo[0]?.Origin,
      IdTipoTejido: encabezadoTempo[0]?.IdTipoTejido,
      TipoTejido: encabezadoTempo[0]?.TipoTejido,
      Efecto: encabezadoTempo[0]?.Efecto,
      IdEfecto: encabezadoTempo[0]?.IdEfecto,
      Yarn: encabezadoTempo[0].Yarn,
      Filamentos: encabezadoTempo[0]?.Filamentos,
      IdLoster: encabezadoTempo[0]?.IdLoster,
      Loster: encabezadoTempo[0]?.Loster,
      IdRecycle: encabezadoTempo[0]?.IdRecycle,
      Recycled: encabezadoTempo[0]?.Recycled,
      IdCross: encabezadoTempo[0]?.IdCross,
      CrossSection: encabezadoTempo[0]?.CrossSection,
      Heat: encabezadoTempo[0]?.Heat,
      HeatL: encabezadoTempo[0]?.Heat,
      IdHeat: encabezadoTempo[0]?.Heat === '1H' ? 1 : 2,
      IdPlay: encabezadoTempo[0]?.Play === 1 ? 1 : 2,
    })

    setLoading(false)
  }
  
  const duplicarCotizacion = async(encabezado) => {
    if(encabezado?.IdYarnTitle > 0){
      setLoading(true)
      const resp = await ObtenerSiguienteCorrelativoS()

      setValues({
        ...values,
        IdYarnTitle: -1,
        Correlativo: resp[0]?.Correlativo,
      })

      setTitulo('Agregar Yarn Synthetic')
      setButton('Guardar')
      
      setTimeout(() => {        
        toastShow(toast, "success", "Nuevo", 'Información duplicada.');
        setLoading(false)
      }, 700);
      
    }else{
      toastShow(toast, "error", "Error", 'Guarde la cotización antes de duplicarla.');
    }
  }

  const DialogFooter = (
    <React.Fragment>
      <Button
        label={getLabel(baseLang, "cancelar", config.language)}
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={button ? button : modo === "Crear" ? `${getLabel(baseLang, "btnGuardar", config.language)}` : `${getLabel(baseLang, "btnEditar", config.language)}`}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarDatos}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (dialog) {
      getValoresIniciales();
    }
  }, [dialog]);

  const dialogTitle = modo === "Crear" ? `${getLabel(baseLang, "Agregar Yarn Spandex", config.language)}` : `${getLabel(baseLang, "Editar Yarn Spandex", config.language)}`;

  const construirYarnText = useCallback(() => {
    let IdDenier = values?.Calibre?.Calibre || values?.Calibre || '';
    let Loster = values?.Loster?.Loster || values?.Loster || '';
    let IdOrigin = values?.Origin?.IdOrigin || values?.IdOrigin || '';
    let Origin = IdOrigin === 1 ? '01' : IdOrigin === 2 ? '02' : '';
    let TipoTejido = values?.TipoTejido?.TipoTejido || values?.TipoTejido || '';


    let Yarn = [
      IdDenier ? `${IdDenier} D 100% Spandex` : '',
      Loster,
      TipoTejido,
      Origin
    ]
      .filter(Boolean)
      .join(' ');

    if (values.Yarn !== Yarn) {
      setValues((prevValues) => ({
        ...prevValues,
        Yarn
      }));
    }
  }, [values, setValues]); 

  useEffect(() => {
    construirYarnText();
  }, [values, construirYarnText]);

  return (
    <div>
      <Dialog
        visible={dialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
        style={{ width: '50%'}}
      >
        <Toast ref={toast} style={{ zIndex: 50000 }} />
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100", margin: "auto" }}>
            <div className="d-flex align-items-center mx-2">
              <h3 className="me-3">{titulo ? titulo : dialogTitle}</h3>
              {values?.Correlativo && (
                <h2><strong>{values?.Correlativo}</strong></h2>
              )}
            </div>

            <div className="mx-2">

              <div className="d-flex gap-2 mx-2">
                <div className="field mt-2">
                  <span className="p-float-label">
                    <AutoCompleteDropdown
                      name={"Calibre"}
                      value={values.Calibre}
                      items={calibres}
                      field={"Calibre"}
                      label={getLabel(baseLang, "Denier", config.language)}
                      handleInputChange={handleInputChange}
                      className={error.IdCalibre ? "p-invalid" : ""}
                    />
                  </span>
                </div>

                <div className="field mt-2">
                  <span className="p-float-label">
                    <AutoCompleteDropdown
                      name={"Loster"}
                      value={values.Loster}
                      items={loster}
                      field={"Loster"}
                      label={getLabel(baseLang, "Luster", config.language)}
                      handleInputChange={handleInputChange}
                      className={error.IdLoster ? "p-invalid" : ""}
                    />
                  </span>
                </div>

                <div className="field mt-2">
                  <span className="p-float-label">
                    <AutoCompleteDropdown
                      name={"TipoTejido"}
                      value={values.TipoTejido}
                      items={tipoTejido}
                      field={"TipoTejido"}
                      label={getLabel(baseLang, "TipoTejido", config.language)}
                      handleInputChange={handleInputChange}
                      className={error.IdTipoTejido ? "p-invalid" : ""}
                    />
                  </span>
                </div>

                <div className="field mt-2" style={{width: 230}}>
                  <span className="p-float-label">
                    <AutoCompleteDropdown
                      name={"Origin"}
                      value={values.Origin}
                      items={origen}
                      field={"Origin"}
                      label={getLabel(baseLang, "Origin", config.language)}
                      handleInputChange={handleInputChange}
                      className={error.IdOrigin ? "p-invalid" : ""}
                    />
                  </span>
                </div>
              </div>

              <div className="d-flex gap-2 mx-2 mt-4">
                <div className="field mt-2 col-12">
                  <span className="p-float-label">
                    <InputText
                      name="Yarn"
                      value={values.Yarn}
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                      disabled
                    />
                    <label htmlFor="Yarn">{getLabel(baseLang, "Yarn Spec", config.language)}</label>
                  </span>
                </div>
              </div>

              <div className="field mt-3 d-flex flex-end">
                <Button
                  icon="pi pi-copy"
                  type="button"
                  disabled={ (values?.IdYarnTitle <= 0)}
                  onClick={() => duplicarCotizacion(values)}
                  tooltip="Duplicar"
                  style={{ marginLeft: 1, zIndex: 999999 }}
                />
              </div>

            </div>
        
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default YarnSpandexCRUD;

